import ViewSubscriptionReceiptSection from "../../components/NewDesign/SubscriptionPage/ViewSubscriptionReceiptSection/ViewSubscriptionReceiptSection";
import Page from "../../components/Page";

const ViewSubscriptionReceiptPage = () => {
    return (
        <>
            <Page>
                <ViewSubscriptionReceiptSection />
            </Page>
        </>
    )
}

export default ViewSubscriptionReceiptPage